import { useEffect } from 'react'

interface PageMeta {
  title: string
  description?: string
}

function upsertMeta(name: string, content: string) {
  if (typeof document === 'undefined') return
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function upsertProperty(property: string, content: string) {
  if (typeof document === 'undefined') return
  let tag = document.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  )
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    if (typeof document === 'undefined') return
    document.title = title
    if (description) {
      upsertMeta('description', description)
      upsertProperty('og:title', title)
      upsertProperty('og:description', description)
    }
  }, [title, description])
}
